import { clearStorage } from "../../utils/Helper/CheckAuth";

//scroll to top
export function scroll_to_top(type) {
  window.scrollTo({
    top: 0,
    behavior: type,
    /* you can also use 'auto' behaviour
       in place of 'smooth' */
  });
}
//progress loading
export function showLoading() {
  document.getElementById("loadingmsg").style.display = "block";
  document.getElementById("loadingover").style.display = "block";
  document.getElementById("uploadpercentageajax").innerHTML = "";
}
export function stopLoading() {
  document.getElementById("loadingmsg").style.display = "none";
  document.getElementById("loadingover").style.display = "none";
}
export function showLoadingPercentage(progresspercentage) {
  document.getElementById("uploadpercentageajax").innerHTML = "";
  document.getElementById("uploadpercentageajax").innerHTML =
    '<font size="10px" color="white">' + progresspercentage + "%</font>";
  console.log("called " + progresspercentage);
}
//app route link
export function gotologin() {
  clearStorage();
  document.getElementById("app_login_link").click();
}
export function gotohome() {
  document.getElementById("app_home_link").click();
}
export function gotoeditprofile() {
  document.getElementById("app_edit_profile_link").click();
}
export function gotomyprofile() {
  document.getElementById("app_my_profile_link").click();
}
//common input validation
export function onlynumber(e, max) {
  var textpattern = /^[0-9]*$/;
  if (e.target.value.match(textpattern) && e.target.value.length <= max) {
    return true;
  }
  return false;
}
export function ismobileno(mobileno) {
  var phoneno = /^[6789]\d{9}$/;
  if (mobileno.match(phoneno)) {
    return true;
  }
  return false;
}
export function isvalidotp(enterotp) {
  var otpformat = /^[0-9]{6}$/;
  if (enterotp.match(otpformat)) {
    return true;
  }
  return false;
}
//fun_input_focus
export function fun_input_focus(input_id) {
  //focus in text input field
  setTimeout(
    function () {
      document.getElementById(input_id).focus();
    }.bind(this),
    500 // Change to duration of the animation
  );
}
//sent_clean_var
export function sent_clean_var(text) {
  return text.replace(/'/g, "\\'");
}
